import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-xmark",
  "use": "icon-xmark-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill-rule=\"evenodd\" viewBox=\"0 0 1024 1024\" id=\"icon-xmark\"><path d=\"M777.6 819.2c-12.8 0-19.2-6.4-25.6-12.8L227.2 281.6c-12.8-12.8-12.8-38.4 0-57.6 12.8-12.8 38.4-12.8 57.6 0l524.8 524.8c12.8 12.8 12.8 38.4 0 57.6C796.8 812.8 790.4 819.2 777.6 819.2z\" /><path d=\"M252.8 819.2c-12.8 0-19.2-6.4-25.6-12.8-12.8-12.8-12.8-38.4 0-57.6l524.8-524.8c12.8-12.8 38.4-12.8 57.6 0 12.8 12.8 12.8 38.4 0 57.6l-524.8 524.8C272 812.8 259.2 819.2 252.8 819.2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol